import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { RestProvider } from '../../providers/rest/rest';
import { ToastController } from 'ionic-angular';
import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';
/**
 * Generated class for the MembersProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage {
  private registerUpdate: any;
  processing:boolean;
  uploadImage: string;
  private Image = [];
  private password1: any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private data: DataProvider,
    private rest: RestProvider,
    private toastCtrl: ToastController,) {
  }


  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Миний профайл';
    this.uploadImage = this.data.image;
  }

  isReadonly() {
    return true;
  }
  setup(){
    if( !this.data.userName ){
      this.data.userName == null;
      this.showToast1('Та нэр оруулаагүй байна!!!');
      return;
    }
    if( !this.data.password ){
      this.data.password == null;
      this.showToast1('Та нууц үг оруулаагүй байна!!!');
      return;
    } else if(this.data.password != this.password1) {
      this.showToast1('Нууц үг зөрж байна.');
      return;
    }
    this.rest.registerUpdate(this.data.userId, this.data.userName, this.data.password).subscribe(res => {
      this.registerUpdate = res;
      if(res.msg == null) {
        this.showToast1('Та мэдээллээ бүрэн оруулна уу.');
      } else if(res.msg == 'ok') {
        this.showToast('Амжилттай заслаа.');
      } else {
        this.showToast1('Бүртгэлтэй хэрэглэгч байна.');
      }
    });
  }


  presentActionSheet(fileLoader) {
    fileLoader.click();
    var that = this;
    fileLoader.onchange = function () {
      var file = fileLoader.files[0];
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        that.processing = true;
        // let src = (HTMLElement as ElementRef) document.getElementById('checkinImage').src;
        that.getOrientation(fileLoader.files[0], function (orientation) {
          if (orientation > 1) {
            that.resetOrientation(reader.result, orientation, function (resetBase64Image) {
              that.uploadImage = resetBase64Image;
            });
          } else {
            that.uploadImage = reader.result;
            that.rest.Image(that.data.userId, that.uploadImage).subscribe(res =>{
              that.data.image = that.uploadImage;
            });
          }
        });
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }
imageLoaded(){
  this.processing = false;
}
getOrientation(file, callback) {
  var reader = new FileReader();
  reader.onload = function (e:any) {

    var view = new DataView(e.target.result);
    if (view.getUint16(0, false) != 0xFFD8) return callback(-2);
    var length = view.byteLength, offset = 2;
    while (offset < length) {
      var marker = view.getUint16(offset, false);
      offset += 2;
      if (marker == 0xFFE1) {
        if (view.getUint32(offset += 2, false) != 0x45786966) return callback(-1);
        var little = view.getUint16(offset += 6, false) == 0x4949;
        offset += view.getUint32(offset + 4, little);
        var tags = view.getUint16(offset, little);
        offset += 2;
        for (var i = 0; i < tags; i++)
          if (view.getUint16(offset + (i * 12), little) == 0x0112)
            return callback(view.getUint16(offset + (i * 12) + 8, little));
      }
      else if ((marker & 0xFF00) != 0xFF00) break;
      else offset += view.getUint16(offset, false);
    }
    return callback(-1);
  };
  reader.readAsArrayBuffer(file);
}
resetOrientation(srcBase64, srcOrientation, callback) {
  var img = new Image();

  img.onload = function () {
    var width = img.width,
      height = img.height,
      canvas = document.createElement('canvas'),
      ctx = canvas.getContext("2d");

    // set proper canvas dimensions before transform & export
    if (4 < srcOrientation && srcOrientation < 9) {
      canvas.width = height;
      canvas.height = width;
    } else {
      canvas.width = width;
      canvas.height = height;
    }

    // transform context before drawing image
    switch (srcOrientation) {
      case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
      case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
      case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
      case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
      case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
      case 7: ctx.transform(0, -1, -1, 0, height, width); break;
      case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
      default: break;
    }

    // draw image
    ctx.drawImage(img, 0, 0);

    // export base64
    callback(canvas.toDataURL());
  };

  img.src = srcBase64;
}
removePic() {
  this.uploadImage = null;
}




showToast(str: any) {
  let toast = this.toastCtrl.create({
    message: str,
    position: 'middle',
    duration: 5000,
    cssClass: "toast-success"
  });
  toast.present();
}
showToast1(str: any) {
  let toast = this.toastCtrl.create({
    message: str,
    position: 'middle',
    duration: 5000,
    cssClass: "toast-unsuccess"
  });
  toast.present();
}
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts